"use strict";

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.UrlProvider = void 0;
var _types = require("../types"),
  _constants = require("./constants"),
  _types2 = require("./types"),
  _validator = require("../utilities/validator");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var UrlProvider = /*#__PURE__*/function () {
  function UrlProvider() {
    _classCallCheck(this, UrlProvider);
    _defineProperty(this, "ready", !1), _defineProperty(this, "isCustomDomain", !1), _defineProperty(this, "domains", _constants.DEFAULT_DOMAINS), _defineProperty(this, "siteCode", void 0), _defineProperty(this, "environment", void 0), _defineProperty(this, "packageInfo", void 0);
  }
  return _createClass(UrlProvider, [{
    key: "initialize",
    value: function initialize(a) {
      var b = a.domain,
        c = a.siteCode,
        d = a.packageInfo,
        e = a.environment;
      this.siteCode = c, this.environment = e, this.packageInfo = d, this.ready = !0, this.setDomains(b);
    }
  }, {
    key: "dataApiDomain",
    set: function set(a) {
      if (!this.isCustomDomain) return void (this.domains[_types2.UrlType.DataApi] = a);
      var b = a.split(".")[0],
        c = this.domains[_types2.UrlType.DataApi];
      this.domains[_types2.UrlType.DataApi] = c.replace(/^[^.]+/, b);
    }
  }, {
    key: "getClientConfigurationUrl",
    value: function getClientConfigurationUrl(a) {
      this.isInitialized();
      var b = "https://".concat(this.domains[_types2.UrlType.ClientConfiguration], "/"),
        c = this.environment === _types.Environment.Production ? "" : _constants.UrlFirstParameter.Environment + this.environment;
      var d = "";
      return a && (c ? d = _constants.UrlParameter.Ts + a : d = _constants.UrlFirstParameter.Ts + a), b + this.siteCode + c + d;
    }
  }, {
    key: "getEventSourceUrl",
    value: function getEventSourceUrl() {
      return this.isInitialized(), "https://".concat(this.domains[_types2.UrlType.Events], ":8110/").concat(_constants.UrlQuery.Sse).concat(this.siteCode);
    }
  }, {
    key: "getRemoteDataUrl",
    value: function getRemoteDataUrl(a) {
      return this.isInitialized(), this.getDataApiUrl(_types2.DataApiQuery.DataMap) + this.siteCode + _constants.UrlParameter.Key + encodeURI(a);
    }
  }, {
    key: "getVisitorDataUrl",
    value: function getVisitorDataUrl(a) {
      var b = a.visitorCode,
        c = a.filters,
        d = a.isMappingIdentifier;
      this.isInitialized();
      var e = c.customData,
        f = c.previousVisitAmount,
        g = c.currentVisit,
        h = c.conversions,
        i = c.geolocation,
        j = c.experiments,
        k = c.pageViews,
        l = c.device,
        m = c.browser,
        n = c.operatingSystem,
        o = c.kcs,
        p = c.visitorCode,
        q = d ? _constants.UrlParameter.MappingValue : _constants.UrlParameter.VisitorCode,
        r = e || p ? _constants.UrlParameter.CustomData + !0 : "",
        s = h ? _constants.UrlParameter.Conversion + !0 : "",
        t = i ? _constants.UrlParameter.Geolocation + !0 : "",
        u = j ? _constants.UrlParameter.Experiment + !0 : "",
        v = k ? _constants.UrlParameter.Page + !0 : "",
        w = !!(l || m || n) ? _constants.UrlParameter.StaticData + !0 : "",
        x = g ? _constants.UrlParameter.CurrentVisit + !0 : "",
        y = o ? _constants.UrlParameter.Kcs + !0 : "",
        z = "number" == typeof f ? _constants.UrlParameter.MaxNumberPreviousVisits + f : _constants.UrlParameter.MaxNumberPreviousVisits + 1;
      return this.getDataApiUrl(_types2.DataApiQuery.VisitData) + this.siteCode + q + b + z + r + s + t + u + v + w + x + y;
    }
  }, {
    key: "getTrackingUrl",
    value: function getTrackingUrl(a) {
      this.isInitialized();
      var _this$packageInfo = this.packageInfo,
        b = _this$packageInfo.type,
        c = _this$packageInfo.version;
      var d = this.getDataApiUrl(_types2.DataApiQuery.VisitEvent) + this.siteCode + _constants.UrlParameter.SdkName + b.toLowerCase() + _constants.UrlParameter.SdkVersion + c;
      return a && (d += _constants.UrlParameter.BodyUa + !0), d;
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.ready) throw new Error("UrlProvider is not initialized");
    }
  }, {
    key: "getDataApiUrl",
    value: function getDataApiUrl(a) {
      if (!this.domains[_types2.UrlType.DataApi]) throw new Error("Data API domain is not set");
      var b = "https://".concat(this.domains[_types2.UrlType.DataApi]);
      return a === _types2.DataApiQuery.VisitEvent ? "".concat(b, "/").concat(_constants.UrlTracking.Visit + _constants.UrlQuery.Events) : a === _types2.DataApiQuery.VisitData ? "".concat(b, "/").concat(_constants.UrlTracking.Visit + _constants.UrlQuery.Visitor) : a === _types2.DataApiQuery.DataMap ? "".concat(b, "/").concat(_constants.UrlTracking.Map + _constants.UrlQuery.Map) : void 0;
    }
  }, {
    key: "setDomains",
    value: function setDomains(a) {
      if (a) {
        var b = _validator.Validator.validateDomain(a);
        b.ok && (a = b.data, a = a.replace(/^\.+|\.+$/g, ""), this.isCustomDomain = !0, this.domains[_types2.UrlType.DataApi] = "data." + a, this.domains[_types2.UrlType.Events] = "events." + a, this.domains[_types2.UrlType.ClientConfiguration] = "sdk-config." + a);
      }
    }
  }]);
}();
exports.UrlProvider = UrlProvider;